import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {IndicatorService, LandmarkService} from '../../apiModule1';

export const landmarksResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: LandmarkService = inject(LandmarkService)) => {
  return service.apiLandmarkGet({}, 'body', false, {transferCache: false});
};
